var UUID = /** @class */ (function () {
    function UUID() {
    }
    Object.defineProperty(UUID, "Current", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    UUID.Next = function () {
        return this.id++;
    };
    UUID.id = 0;
    return UUID;
}());
export { UUID };
